const NoRecord = ({ className }) => {
  return (
    <div className="col-md-12 text-center">
      <p className={className}>No records found.</p>
    </div>
  );
};

export default NoRecord;
